import { messageSentry } from "../../App";
import api from "../infra/api";

export interface Pessoal {
  pessoal_nome: string;
  pessoal_email: string;
  pessoal_salario: string;
  pessoal_sexo: string;
  pessoal_dtnasc: string;
  pessoal_cep: string;
  pessoal_endereco: string;
  pessoal_numero: string;
  pessoal_bairro: string;
  pessoal_uf: string;
  pessoal_cidade: string;
  pessoal_complemento: string;
  pessoal_codestcivil: string;
  pessoal_cargos: PessoalCargo[];
  pessoal_telefones: PessoalTelefone[];
}

export interface PessoalCargo {
  codigo: string;
  codigo_id: number;
  nome: string;
}

export interface PessoalTelefone {
  ddd: string;
  ramal: string;
  phone: string;
  name: string;
}

export interface ProcessVacancyType {
  vacancy: number;
  name: string;
}

export const update = async (body: Pessoal): Promise<any | boolean> => {
  const updateEndpoint =
    process.env.REACT_APP_API_URL + `/candidate/user/update`;
  try {
    const response = await api(updateEndpoint, {
      method: "PUT",
      body: JSON.stringify({ body }),
      mode: "cors",
      headers: {
        "content-Type": "application/json",
      },
    });

    if (response.status >= 203) {
      return false;
    }

    const data = await response.json();

    return data;
  } catch (err) {
    console.log(err);
    messageSentry(String(err));
    return false;
  }
};

export const postProcess = async (
  body: ProcessVacancyType
): Promise<boolean | any> => {
  const updateEndpoint =
    process.env.REACT_APP_API_URL + `/candidate/user/process`;
  try {
    const response = await api(updateEndpoint, {
      method: "POST",
      body: JSON.stringify({ body }),
      mode: "cors",
      headers: {
        "content-Type": "application/json",
      },
    });

    if (response.status >= 203) {
      return false;
    }

    const data = await response.json();

    return data;
  } catch (err) {
    console.log(err);
    messageSentry(String(err));
    return false;
  }
};

export const deleteJOB = async (
  id: number | null | undefined
): Promise<boolean | any> => {
  const deleteEndpoint =
    process.env.REACT_APP_API_URL + `/candidate/user/job/` + id;
  try {
    const response = await api(deleteEndpoint, {
      method: "DELETE",
      mode: "cors",
      headers: {
        "content-Type": "application/json",
      },
    });

    if (response.status >= 203) {
      return false;
    }

    const data = await response.json();

    return data;
  } catch (err) {
    console.log(err);
    messageSentry(String(err));
    return false;
  }
};

export const getCandidate = async (): Promise<any | boolean> => {
  const updateEndpoint = process.env.REACT_APP_API_URL + `/candidate/user/get`;
  try {
    const response = await api(updateEndpoint);

    if (response.status >= 203) {
      return false;
    }

    const data = await response.json();
    return data;
  } catch (err) {
    console.log(err);
    messageSentry(String(err));
    return false;
  }
};

export const uploadCandidateAvatar = async (
  file: File
): Promise<{ img_usuario: string } | false> => {
  const endpoint =
    process.env.REACT_APP_API_URL + `/candidate/user/avatar`;
  try {
    const formData = new FormData();
    formData.append("file", file);
    const response = await api(endpoint, {
      method: "POST",
      body: formData,
    });
    if (response.status >= 203) {
      return false;
    }
    const data = await response.json();
    return data;
  } catch (err) {
    console.log(err);
    messageSentry(String(err));
    return false;
  }
};

export const getProcess = async (): Promise<any | boolean> => {
  const updateEndpoint =
    process.env.REACT_APP_API_URL + `/candidate/user/process`;
  try {
    const response = await api(updateEndpoint);

    if (response.status >= 203) {
      return false;
    }

    const data = await response.json();
    return data;
  } catch (err) {
    console.log(err);
    messageSentry(String(err));
    return false;
  }
};
